<template>
  <div>
    <!-- Fondo oscuro -->
    <div v-show="isVisible" class="overlay" @click="handleOverlayClick"></div>

    <!-- Modal -->
    <md-card v-show="isVisible" class="captcha-modal" @click.stop>
      <div class="modal-header">
        <h4 class="modal-title">Completa el reCAPTCHA:</h4>
      </div>
      <div class="modal-content">
        <!-- Google reCAPTCHA -->
        <vue-recaptcha
          sitekey="6Le6KAwcAAAAAHxMleQ5SVIUZ0jLIU2yzhahk8zM"
          @verify="onVerify"
          @expired="onExpired"
        ></vue-recaptcha>
      </div>

      <!-- Botón para validar -->
      <v-btn
        class="btn-continuar"
        block
        @click="validateCaptcha"
        :disabled="!recaptchaToken"
      >
        Continuar
      </v-btn>
    </md-card>
  </div>
</template>


<script>
import VueRecaptcha from "vue-recaptcha";

export default {
  name: "CaptchaModal",
  components: {
    VueRecaptcha,
  },
  data() {
    return {
      isVisible: false,
      recaptchaToken: "", 
     
    };
  },
  methods: {
    openModal() {
      this.isVisible = true;
    },
    closeModal() {
      this.isVisible = false;
    },
    validateCaptcha() {
      if (this.recaptchaToken) {
        this.$emit("captchaVerified", this.recaptchaToken); // Emite el evento con el token
        this.closeModal();
      } else {
        alert("Por favor, completa el reCAPTCHA antes de continuar.");
      }
    },
    handleOverlayClick() {
      this.closeModal();
    },
    onVerify(token) {
      this.recaptchaToken = token; // Captura el token generado por reCAPTCHA
    },
    onExpired() {
      this.recaptchaToken = ""; // Limpia el token cuando expira
    },
  },
};
</script>

<style scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  z-index: 1000;
}
.modal-content {
  margin-bottom: 12px;
  border: none;
}
.captcha-modal {
  max-width: 400px;
  margin: 20px auto;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  background-color: white;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1010;
}

.modal-header {
  text-align: center;
  margin-bottom: 20px;
}

.modal-title {
  color: black;
  font-size: 15px;
}

.btn-continuar {
  background-color: #87ceeb !important; /* Azul cielo */
  color: white !important;
}
</style>
